import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-backdrop',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="visible"
      class="fixed inset-0 bg-black-50 dark:bg-black-70 backdrop-blur-sm transition-opacity duration-300"
      [class.z-50]="zIndex === 50"
      [class.z-[60]]="zIndex === 60"
      [class.z-[70]]="zIndex === 70"
      [class.z-[9999]]="zIndex === 9999"
      [class.z-[100]]="zIndex === 100"
      (click)="handleClick()"
    ></div>
  `,
})
export class BackdropComponent {
  @Input() visible = false;
  @Input() zIndex: 50 | 60 | 70 | 100 | 9999 = 50;
  @Input() dismissible = true;
  @Output() backdropClick = new EventEmitter<void>();

  handleClick() {
    if (this.dismissible) {
      this.backdropClick.emit();
    }
  }
}

